module.exports = __webpack_public_path__ + "img/delete.e9178097.png";